import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Search as SearchIcon, Tune as FilterListIcon } from '@mui/icons-material';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  width?: string;
  borderRadius?: string;
  height?: string;
  fontSize?: string;
  onFilterClick?: () => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder = 'キーワードで検索',
  width = '466px',
  borderRadius = '24px',
  height = '60px',
  fontSize = '16px',
  onFilterClick,
}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        backgroundColor: '#E7E7E7',
        borderRadius,
        height,
        display: 'flex',
        alignItems: 'center',
        padding: '0 12px',
        width,
      }}
    >
      <SearchIcon sx={{ color: '#666666', fontSize: '22px', mr: 1.5 }} />
      <Box
        component="input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          border: 'none',
          outline: 'none',
          backgroundColor: '#E7E7E7',
          flex: 1,
          fontSize,
          color: '#000000',
          '&::placeholder': {
            color: '#666666',
            opacity: 1,
          },
        }}
      />
      <Box
        sx={{
          width: '1px',
          height: '24px',
          backgroundColor: '#E0E0E0',
          mx: 1.5,
        }}
      />
      <IconButton
        size="small"
        onClick={onFilterClick}
        sx={{
          color: '#666666',
          padding: '4px',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <FilterListIcon sx={{ fontSize: '22px' }} />
      </IconButton>
    </Box>
  );
};

